import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useCommunicationChatEventsApi } from '@/features/api/hooks/communication-chat-events/useCommunicationChatEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

type MutationParams = {
  readTime: number;
};

export const useSetChatRead = (chatId: string) => {
  const queryClient = useQueryClient();
  const api = useCommunicationChatEventsApi();

  return useApiMutation({
    mutationFn: async ({ readTime }: MutationParams) => {
      await api.setRead({
        clientChatReadRequest: { chatId, readTime }
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.CHAT, chatId],
        refetchType: 'all'
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.OWN_CHATS],
        refetchType: 'all'
      });
    }
  });
};
